import { render } from "./seconPart.vue?vue&type=template&id=6be69619"
import script from "./seconPart.vue?vue&type=script&lang=js"
export * from "./seconPart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__